import { Button, Col, Divider, Row, Space, Switch, Typography } from 'antd'
import Messages, { shouldShow } from '../common/Messages'
import { EyeInvisibleOutlined as NotVisibleIcon, EyeOutlined as VisibleIcon } from '@ant-design/icons'
import { defaultDateTime, durationInWords, formatDateTime, parseDateTime } from '../../util/dateTimeUtil'
import { useCallback, useEffect, useReducer, useState } from 'react'

import Message from '../common/Message'
import MessageModal from './MessageModal'
import Section from '../common/Section'
import { Table } from 'ant-table-extensions'
import _ from 'lodash'
import axios from '../../axios/axios'
import { compareStrings } from '../../util/compareUtil'
import { getLessonDescription } from '../../util/adultLessonUtil'
import { isPast } from 'date-fns'
import { notifyError } from '../../util/notifyUtil'
import useAdultLessonSignups from '../../hooks/api/useAdultLessonSignups'
import { useForceUpdate } from '../../hooks/useForceUpdate'
import useMessages from '../../hooks/api/useMessages'

const { Paragraph } = Typography

const colProps = {
  style: {
    padding: '1em',
  },
}

const MessagesPage = () => {
  const [state, setState] = useState(0)
  const { messages } = useMessages(state)
  const [message, setMessage] = useState()
  const [modalVisible, setModalVisible] = useState(false)

  const handleAdd = () => {
    setMessage(null)
    setModalVisible(true)
  }
  const handleEdit = (message) => {
    setMessage(message)
    setModalVisible(true)
  }
  const handleSave = async (message) => {
    try {
      let { id, expires } = message
      expires = new Date(expires).toISOString()
      message = { ...message, expires }
      const { data: updated } = id
        ? await axios.put('/admin/message', message)
        : await axios.post('/admin/message', message)
      const i = _.findIndex(messages, { id: updated.id })
      const newMessages = [...messages]
      if (_.isNil(i)) {
        newMessages.push(updated)
      } else {
        newMessages.splice(i, 1, updated)
      }
      setModalVisible(false)
      setState(state + 1)
    } catch (e) {
      notifyError('message-error', e)
    }
  }
  const handleCancel = () => {
    setModalVisible(false)
  }

  const getFriendlyMessageType = (value) => {
    switch (value) {
      case 'cancelledWeather':
        return 'Rain'
      case 'cancelledOther':
        return 'Cancelled'
      case 'reminder':
        return 'Reminder'
      case 'general':
        return 'Other'

      default:
        return ''
    }
  }

  const columns = [
    {
      title: '',
      render: (value, record) => {
        return (
          <Button type="link" onClick={() => handleEdit(record)}>
            {' '}
            Edit{' '}
          </Button>
        )
      },
    },
    {
      title: 'Visible now?',
      render: (value, record) => (shouldShow(record) ? 'Yes' : 'No'),
    },
    {
      title: 'Expires',
      dataIndex: 'expires',
      render: (value, record) => formatDateTime(value, 'EEE MMM dd hh:mma'),
    },
    {
      title: 'Heading',
      dataIndex: ['heading'],
    },
    {
      title: 'Type',
      dataIndex: ['messageType'],
      render: getFriendlyMessageType,
    },
    {
      title: 'Enabled',
      dataIndex: ['visible'],
      render: (value, record) => (value ? 'Yes' : 'No'),
    },
  ]

  return (
    <>
      <MessageModal messageToEdit={message} onOk={handleSave} onCancel={handleCancel} visible={modalVisible} />

      {/* <div style={{ overflowX: 'scroll' }}>
        <Section title="Messages" />
        <Paragraph>
          Configure messages that will appear at the top of the home page. Messages are only visible there if they're
          enabled and have an expiry date in the future. Messages that are currently visible appear in yellow in the
          table.
        </Paragraph>
        <Button onClick={handleAdd} type="primary">
          Add message
        </Button>
        <Table
          rowClassName={(record, index) => (shouldShow(record) ? 'messageEnabled' : 'messageDisabled')}
          className="compactTable"
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={messages}
          pagination={false}
        />
      </div> */}

      <Section title="Messages" />
      <Paragraph>
        Configure messages that will appear at the top of the home page. Messages are only visible there if they're
        enabled and have an expiry date in the future. Currently visible messages appear at the top of the list below.
      </Paragraph>
      <Paragraph>
        <Button onClick={handleAdd} type="primary">
          Add a new message
        </Button>
      </Paragraph>
      <Row>
        <Col {...colProps} xs={24}>
          <Messages
            forceUpdate={Math.random()}
            showAll
            visibleFirst
            extraContentProps={(message) => ({
              // style: {
              //   backgroundColor: message.visible && shouldShow(message) ? '#c2f7b7' : 'transparent',
              //   minWidth: '20em',
              //   float: 'left',
              //   textAlign: 'left',
              //   paddingLeft: '1em',
              //   paddingRight: '1em',
              //   paddingTop: '0.5em',
              //   paddingBottom: '0.5em',
              //   borderTop: '1px solid #eee',
              // },
              style: {
                // backgroundColor: message.visible && shouldShow(message) ? '#c2f7b7' : 'transparent',
                marginBottom: '0.3em',
              },
            })}
            // extraContent={(message) => (
            //   <div style={{ fontSize: '0.8em' }}>
            //     <Button
            //       style={{ paddingLeft: 0, paddingBottom: '1em' }}
            //       type="link"
            //       onClick={() => handleEdit(message)}
            //     >
            //       Edit
            //     </Button>{' '}
            //     <br />
            //     {!message.visible ? (
            //       'Disabled'
            //     ) : (
            //       <>
            //         {isPast(parseDateTime(message.expires)) ? 'Expired' : 'Visible now; expires'}{' '}
            //         {durationInWords(message.expires, true)} ({formatDateTime(message.expires, 'EEE MMM dd hh:mma')})
            //       </>
            //     )}
            //     <br />
            //   </div>
            // )}
            extraContent={(message) => (
              <div>
                <Divider />
                <Row
                  justify="space-between"
                  style={
                    {
                      // maxWidth: '70em',
                      // marginLeft: 'auto',
                      // marginRight: 'auto',
                      // paddingLeft: '2em',
                      // paddingRight: '2em',
                    }
                  }
                >
                  <Col flex={1}>
                    <Button style={{ marginRight: '1em' }} onClick={() => handleEdit(message)} type="link">
                      Edit message
                    </Button>
                    {!message.visible ? (
                      'Message is disabled.'
                    ) : (
                      <>
                        {isPast(parseDateTime(message.expires)) ? (
                          'Expired'
                        ) : (
                          <>
                            <span style={{ margin: '1em', color: '#000', backgroundColor: 'yellow', padding: '0.4em' }}>
                              Currently visible
                            </span>{' '}
                            Expires
                          </>
                        )}{' '}
                        {durationInWords(message.expires, true)} ({formatDateTime(message.expires, 'EEE MMM dd hh:mma')}
                        )
                      </>
                    )}
                  </Col>
                </Row>
              </div>
            )}
          />
        </Col>
      </Row>
    </>
  )
}

export default MessagesPage
